import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';

export class FormHelper {
  private static readonly DIGITS_WITH_SPACES = '[0-9 ]+';
  private static readonly CVR_LENGTH = 8;
  private static readonly CVR_PATTERN = '^\\d{8}$';
  private static readonly BFE_NR_LENGTH = 10;
  private static readonly PNUMMER_LENGTH = 10;
  private static readonly ONLY_DIGITS_PATTERN = '^[0-9\\s]+$';
  private static readonly DANSK_TELEFON_PATTERN = '^[0-9]{8}$';
  private static readonly DANSK_TELEFON_LANDEKODE_OR_ANY_PATTERN = '^(?:\\+45|0045)?[1-9]\\d{7}$|^(?:\\+|00)(?!45)[1-9]\\d+$';
  private static readonly EMAIL_PATTERN =
    '^[a-zA-Z0-9.%_+-]+@[-\\wæøåöäüéẞßÆØÅÖÄÜÉ.]+\\.[a-zA-Z]+$';

  static get OnlyDigitsWithspaces(): FormControl {
    return new FormControl('', [Validators.pattern(this.DIGITS_WITH_SPACES)]);
  }

  static get CvrLength(): number {
    return this.CVR_LENGTH;
  }

  static get CvrPattern(): string {
    return this.CVR_PATTERN;
  }

  static get BfeNrLength(): number {
    return this.BFE_NR_LENGTH;
  }

  static get PNummerLength(): number {
    return this.PNUMMER_LENGTH;
  }

  static get OnlyDigitsPattern(): string {
    return this.ONLY_DIGITS_PATTERN;
  }

  static get DanskTelefonPattern(): string {
    return this.DANSK_TELEFON_PATTERN;
  }

  static get DanskLandekodeTelefonEllerTalPattern(): string {
    return this.DANSK_TELEFON_LANDEKODE_OR_ANY_PATTERN;
  }

  static get EmailPattern(): string {
    return this.EMAIL_PATTERN;
  }

  static get DigitsWithSpaces(): ValidatorFn {
    return Validators.pattern(this.DIGITS_WITH_SPACES);
  }

  static get NoValidators() {
    return new FormControl('');
  }

  static isPNummerValid(value: string): boolean {
    return new RegExp(this.OnlyDigitsPattern).test(value);
  }

  static FormControlValid(control: AbstractControl): boolean {
    return !control.errors && control.value;
  }

  static CustomValidator(initValue: any, validators: ValidatorFn[]): FormControl {
    return new FormControl(initValue, validators);
  }

  static RemoveWhitespace(control: AbstractControl) {
    if (control.value.includes(' ')) {
      control.setValue(control.value.replace(/ +/g, ''));
    }
  }

  static isTelefonValid(value: string): boolean {
    return new RegExp(this.DanskTelefonPattern).test(value);
  }

  static isDKTelefonValid(value: string): boolean {
    return new RegExp(this.DanskLandekodeTelefonEllerTalPattern).test(value);
  }

  static isEmailValid(value: string): boolean {
    return new RegExp(this.EmailPattern).test(value);
  }

  static isCvrValid(value: string): boolean {
    return new RegExp(this.CvrPattern).test(value);
  }
}
